<template>
    <div
        class="cta-box"
        :class="classCtaBox"
    >
        <slot name="default"></slot>

        <div
            v-if="
                !disabled &&
                !minimal &&
                (data?.ctaPerksLink || data?.ctaPerksList.length)
            "
            class="content"
        >
            <ul
                v-if="data.ctaPerksList.length"
                class="list"
            >
                <li
                    v-for="(item, index) in data.ctaPerksList"
                    :key="index"
                    class="item"
                >
                    {{ item.title }}
                </li>
            </ul>

            <CmsLink
                v-if="data.ctaPerksLink"
                class="link"
                :link="data.ctaPerksLink"
            />
        </div>
    </div>

    <div
        class="below-cta-box"
        :class="classCtaBox"
    >
        <slot name="below-cta"></slot>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { CtaBoxFragment } from '@/graphql/api'

import CmsLink from '@/components/cms/CmsLink.vue'

const {
    data,
    disabled = false,
    minimal = false,
} = defineProps<{
    data: CtaBoxFragment | undefined | null
    disabled?: boolean
    minimal?: boolean
}>()

const classCtaBox = computed(() => ({
    disabled:
        disabled ||
        minimal ||
        (!data?.ctaPerksLink && !data?.ctaPerksList.length),
    minimal,
}))
</script>

<style lang="scss" scoped>
.cta-box {
    position: relative;

    border: 1px solid $grey-200;
    border-radius: 2px;
    padding: 16px 12px;

    &.disabled,
    &.minimal {
        border: none;
        padding: 0;
    }

    :slotted(.product-cta) {
        position: relative;

        .enquiry-message {
            background: $stone-2;
            display: block;
            padding: 15px 20px;
            margin: 0 0 20px;
            font-size: 0.875rem;
        }
    }

    .content {
        position: relative;

        padding: 24px 32px 0;

        font-family: $effra-font-stack;
        letter-spacing: 0.05em;
        font-size: 0.75rem;
        text-transform: uppercase;
        font-weight: 400;

        .list {
            margin-bottom: 8px;
            list-style-type: disc;
        }

        .link {
            padding-top: 8px;
            color: $grey-500;
            font-weight: 700;
        }
    }
}

.below-cta-box {
    margin-top: 16px;
    padding: 0 12px;

    &.disabled,
    &.minimal {
        margin-top: 0;
        padding: 0;
    }
}
</style>
